var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('Tooltip',{staticClass:"my-4 mr-4",attrs:{"color":"primary","text":"Visualizar","top":""}},[_c('v-icon',_vm._g(_vm._b({attrs:{"small":"","color":"primary"}},'v-icon',_vm.$attrs,false),_vm.$listeners),[_vm._v(" mdi-eye ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }